/** biome-ignore-all lint/nursery/useExplicitType: Zod schema inference */
import { z } from 'zod';
import type { IAPI } from '../../apiResponse';
import { createApiResponseSchema } from '../../apiResponse';

const accountAttributionRowSchema = z.object({
  id: z.number(),
  userId: z.string(),
  touchKind: z.string(),
  source: z.string().nullable(),
  medium: z.string().nullable(),
  campaign: z.string().nullable(),
  term: z.string().nullable(),
  content: z.string().nullable(),
  referrer: z.string().nullable(),
  gclid: z.string().nullable(),
  fbclid: z.string().nullable(),
  ttclid: z.string().nullable(),
  msclkid: z.string().nullable(),
  rawUrl: z.string().nullable(),
  capturedAt: z.number(),
  createdAt: z.number(),
});

const installSourceRowSchema = z.object({
  id: z.number(),
  userId: z.string(),
  deviceId: z.string(),
  platform: z.string(),
  sourceKind: z.string(),
  appleOrgId: z.string().nullable(),
  appleCampaignId: z.string().nullable(),
  appleAdGroupId: z.string().nullable(),
  appleKeywordId: z.string().nullable(),
  appleCountryOrRegion: z.string().nullable(),
  playInstallReferrer: z.string().nullable(),
  playInstallBeginAt: z.number().nullable(),
  playReferrerClickAt: z.number().nullable(),
  rawPayload: z.string().nullable(),
  capturedAt: z.number(),
  createdAt: z.number(),
});

const webVisitorRowSchema = z.object({
  id: z.number(),
  visitorId: z.string(),
  fingerprintHash: z.string(),
  attributionPayload: z.string().nullable(),
  matchedUserId: z.string().nullable(),
  matchedAt: z.number().nullable(),
  createdAt: z.number(),
  expiresAt: z.number(),
});

export const userAttributionV1DataSchema = z.object({
  userId: z.string(),
  firstTouch: accountAttributionRowSchema.nullable(),
  lastTouch: accountAttributionRowSchema.nullable(),
  touches: z.array(accountAttributionRowSchema),
  installSources: z.array(installSourceRowSchema),
  deviceIds: z.array(z.string()),
  webVisitors: z.array(webVisitorRowSchema),
});

export type IUserAttributionV1Data = z.infer<typeof userAttributionV1DataSchema>;
export type IUserAttributionTouchRow = z.infer<typeof accountAttributionRowSchema>;
export type IUserAttributionInstallRow = z.infer<typeof installSourceRowSchema>;
export type IUserAttributionWebVisitorRow = z.infer<typeof webVisitorRowSchema>;

export const getUserAttributionV1ResponseSchema = createApiResponseSchema(
  userAttributionV1DataSchema,
) as z.ZodSchema<IAPI<IUserAttributionV1Data>>;

export type IGetUserAttributionV1Response = IAPI<IUserAttributionV1Data>;
